module.exports = __webpack_public_path__ + "static/img/click_btn.77af9e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/click_btn.png
// module id = t7dF
// module chunks = 1